<template>
  <div>
    <v-card class="mb-4">
      <v-card-text>
        <div class="d-flex align-center ga-5">
          <v-sheet
            class="d-flex align-center justify-center"
            color="light-blue"
            height="54"
            rounded="lg"
            width="54">
            <v-icon color="secondary" icon="mdi-magnify" size="26"></v-icon>
          </v-sheet>
          <div class="d-flex flex-column ga-1">
            <span class="font-size-18 font-weight-bold">Пошук документів</span>
            <span class="font-size-13">
              Зручний засіб пошуку документів в електронному сховищі. Доступні
              атрибутивний та повнотекстовий види пошуку.
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <search-tabs></search-tabs>
    <router-view></router-view>
    <search-results></search-results>
  </div>
</template>

<script lang="ts" setup>
import SearchTabs from '@/pages/search/components/Tabs.vue'
import SearchResults from '@/pages/search/components/SearchResults.vue'
import { initSearch } from '@/pages/search/search'

defineOptions({
  name: 'Search',
})

initSearch()
</script>
